import { Component, OnInit, OnDestroy } from '@angular/core';
import { Experience, WMAIApiService, SchedaIntense, Attachment, Item, Stop, Word, AppStatus, Ost, GisQureyResult, User } from '../../core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, AppInformationService, S3Service, ExpLocalStorage, GeolocationService } from '../../core/services';
import { WgisService } from '../../wgis/wgis.service';
import { WGisDisplayMode } from '../../wgis/wgis.utils';
import { BreakpointObserver } from '@angular/cdk/layout';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators, NgModel } from '@angular/forms';
import { ImageModal, ConfirmModal, SimpleModal, ConfirmFormModal } from '../../core/templates';
import { SuiModalService, TemplateModalConfig, ModalTemplate, ModalSize } from 'ng2-semantic-ui';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { throwIfEmpty } from 'rxjs/operators';
import { callbackify } from 'util';
import { Observable, throwError, Subscription } from 'rxjs';
import * as foo from '../../core/models/functions-cordova';
import { error } from 'protractor';
import WKT from 'ol/format/WKT';
import { Point } from 'ol/geom';

@Component({
  selector: 'app-esperienza-main',
  templateUrl: './esperienza-main.component.html'
})

export class EsperienzaMainComponent implements OnInit, OnDestroy {
  isMapVisible: boolean = false;
  isUserLoggedIn = false;
  isMyExp = false;
  esperienza: Experience;
  schedaintense: SchedaIntense;
  id: number;
  schedaid: number;
  loading: boolean = true;
  imageUrl: string = "";
  firstStep: boolean = false;
  secondStep: boolean = false;
  thirdStep: boolean = false;
  fourthStep: boolean = false;

  canIEdit: boolean = false;
  canIShare: boolean = false;
  canIApprove: boolean = false;
  canIDownload: boolean = false;
  canIRecover: boolean = false;
  canIDelete: boolean = false;
  canIArchive: boolean = false;
  shareOptions: boolean = false;
  cc: boolean = false;

  //variabile che fa attivae il form di rifiuto
  isRejected: boolean = false;

  isSmallScreen: boolean = false;
  isMobile: boolean = false;
  immagine: Attachment;
  immagini: Attachment[] = [];
  currentIndex: number = 0;
  maxIndex: number = 0;
  allegati: Attachment[] = [];
  allegato: Attachment;
  receivers: User[] = [];

  mainForm: FormGroup;
  titolo: string = "";
  htmlContent: string = "";

  itemForm: FormGroup;
  itemtitolo: string = "";
  itemcontent: string = "";
  selectedItem: Item;
  selectedStop: Stop;
  stops: Stop[] = [];
  items: Item[];
  itemdefaulttitle: string;
  itemCaricati: Attachment[] = [];
  itemAllegati: Attachment[] = [];
  itemImmagini: Attachment[] = [];
  itemImmagine: Attachment;
  itemCurrentIndex: number = 0;
  itemMaxIndex: number = 0;
  ostDescrizione: string;

  editorConfig: AngularEditorConfig;

  segnalazioneForm: FormGroup;
  segnalazioneValue: string;
  segnalazioneText: string;
  showSegnalazione = true;
  wordsSegnalazione: Word[] = [];
  geomtype: string = 'point';
  paramsSubscription: any;
  finishdrawing: boolean = false;
  ostSubscription: any;

  checkDownload: boolean;
  checkSyncronize: boolean;

  resolved(captchaResponse: string) {
    // console.log(`Resolved captcha with response: ${captchaResponse}`);
  }

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private wmaiservice: WMAIApiService,
    private auth: AuthService,
    private wgisservice: WgisService,
    private breakpointObserver: BreakpointObserver,
    private activatedroute: ActivatedRoute,
    private translateService: TranslateService,
    private formBuilder: FormBuilder,
    private modalService: SuiModalService,
    private appService: AppInformationService,
    private explocalstorage: ExpLocalStorage,
    private s3Service: S3Service,
    private geolocation: GeolocationService
  ) {
    this.isUserLoggedIn = this.auth.isUserLoggedIn();
    this.wgisservice.wgisVisible.subscribe((mode: WGisDisplayMode) => {
      this.isMapVisible = (mode !== WGisDisplayMode.Invisible);
    });
    this.isMobile = this.appService.iAmMobile();
    // console.log(this.isMobile);
    this.isSmallScreen = breakpointObserver.isMatched('(max-width: 768px)');
  }

  ngOnInit() {
    this.isSmallScreen = this.breakpointObserver.isMatched('(max-width: 768px)');
    this.isMapVisible = this.wgisservice.getMapVisible();
    window.scrollTo(0, 0);

    const titoloCtrl = new FormControl(this.titolo, [Validators.required, Validators.maxLength(50)]);
    const contentCtrl = new FormControl(this.htmlContent);

    this.mainForm = this.formBuilder.group({
      titolo: new FormControl(titoloCtrl),
      htmlContent: new FormControl(contentCtrl),
    });

    this.mainForm.controls['titolo'].patchValue('');
    this.mainForm.controls['htmlContent'].patchValue('');

    const itemtitoloCtrl = new FormControl(this.itemtitolo, [Validators.required, Validators.maxLength(50)]);
    const itemcontentCtrl = new FormControl(this.itemcontent);

    this.itemForm = this.formBuilder.group({
      itemtitolo: new FormControl(itemtitoloCtrl),
      itemcontent: new FormControl(itemcontentCtrl),
    });

    this.itemForm.controls['itemtitolo'].patchValue('');
    this.itemForm.controls['itemcontent'].patchValue('');

    const segnalazioneValueCtrl = new FormControl(this.segnalazioneValue, [Validators.required]);
    const segnalazioneTextCtrl = new FormControl(this.segnalazioneText, [Validators.required]);

    this.segnalazioneForm = this.formBuilder.group({
      segnalazioneValue: new FormControl(segnalazioneValueCtrl),
      segnalazioneText: new FormControl(segnalazioneTextCtrl)
    });

    this.segnalazioneForm.controls['segnalazioneText'].patchValue('');

    //this.id = this.activatedRoute.snapshot.params.id;

    this.paramsSubscription = this.activatedRoute.params.subscribe((param: any) => {
      this.resetView();
      this.id = param['id'];
      if (this.id != null) {
        this.wmaiservice.querySingleEsperienza(this.id, this.translateService.getDefaultLang()).subscribe(data => {
          if (data['data'][0] != null) {
            this.esperienza = data['data'][0];
            // console.log(this.esperienza);
            this.schedaid = this.esperienza.id;
            this.isMyExp = Number(this.auth.getID()) === this.esperienza.fk_users;
            this.getWordsSegnalazione();

            //test utilizzo della mappa con chiamate dirette, passando l'esperienza
            this.wgisservice.clearSelection();
            this.wgisservice.showEsperienzaByObj(this.esperienza);
            if (this.esperienza.scheda_status == 1) {
              switch (this.esperienza.status) {
                case 'public':
                  if (this.auth.getIsAdmin() || this.auth.getIsSupervisor()) {
                    this.canIDelete = true;
                  }
                  this.firstStep = true;
                  this.canIEdit = false;
                  this.appService.changeAppStatus(AppStatus.ViewExp);
                  break;

                case 'private':
                  if (this.auth.isUserLoggedIn) {
                    if (this.isMyExp) {
                      this.canIEdit = true;
                      this.secondStep = true;
                      this.canIDownload = true;
                      this.appService.changeAppStatus(AppStatus.EditExp);
                    } else if (data['metadata']['rowCount'] > 0) { //da verificare
                      // console.log(data['metadata']['rowCount']);
                      this.firstStep = true;
                      this.canIDownload = true;
                      this.appService.changeAppStatus(AppStatus.ViewExp);
                    } else {
                      this.router.navigate(['/']);
                    }
                  } else {
                    this.router.navigate(['login/']);
                  }
                  break;

                case 'archived':
                  if (this.auth.isUserLoggedIn) {
                    if (this.isMyExp) {
                      this.canIRecover = true;
                      this.firstStep = true;
                      this.appService.changeAppStatus(AppStatus.ViewExp);
                    } else {
                      this.router.navigate(['/']);
                    }
                  } else {
                    this.router.navigate(['login/']);
                  }
                  break;

                case 'delete':
                  if (this.auth.isUserLoggedIn) {
                    if (this.auth.getIsAdmin() || this.auth.getIsSupervisor()) {
                      this.canIDelete = true;
                    }
                    if (!this.isMyExp && !(this.auth.getIsAdmin() || this.auth.getIsSupervisor())) {
                      this.router.navigate(['/']);
                    } else {
                      this.firstStep = true;
                      this.appService.changeAppStatus(AppStatus.ViewExp);
                      //visibile solo per test
                      //this.canIDelete = true;
                    }
                  }
                  else {
                    this.router.navigate(['login/']);
                  }
                  break;

                case 'wait':
                  if (this.auth.isUserLoggedIn) {
                    if (this.auth.getIsAdmin() || this.auth.getIsSupervisor()) {
                      this.canIApprove = true;
                    }
                    if (!this.isMyExp && !(this.auth.getIsAdmin() || this.auth.getIsSupervisor())) {
                      this.router.navigate(['/']);
                    } else {
                      this.firstStep = true;
                      this.appService.changeAppStatus(AppStatus.ViewExp);
                      //visibile solo per test
                      //this.canIApprove = true;
                    }
                  } else {
                    this.router.navigate(['login/']);
                  }
                  break;
              }

              this.checkExpLocalStorage();

            } else {
              if (this.esperienza.status == 'public') {
                this.firstStep = true;
              } else {
                if (this.auth.isUserLoggedIn && (this.isMyExp || (this.auth.getIsAdmin() || this.auth.getIsSupervisor()))) {
                  this.firstStep = true;
                } else {
                  this.router.navigate(['login/']);
                }
              }
            }
            this.wmaiservice.queryEsperienzaFiles(this.id, '').subscribe(data => {
              // if (data != null) {
              //   this.immagini = data.filter(img => img.resource_mimetype === "jpg" || img.resource_mimetype === "png" || img.resource_mimetype === "jpeg");
              //   this.esperienza.attachments = data;
              //   this.maxIndex = this.immagini.length - 1;
              //   this.immagine = this.immagini[0];
              //   this.esperienza.immagini = this.immagini;
              // }
              if (data != null) {
                data.forEach(allegato => {
                  if (allegato.resource_url.indexOf("png") == -1 && allegato.resource_url.indexOf("jpg") == -1 && allegato.resource_url.indexOf("jpeg") == -1) {
                    this.allegati.push(allegato);
                  } else
                    this.immagini.push(allegato);
                });
                if (this.immagini.length > 0) {
                  this.currentIndex = 0;
                  this.immagine = this.immagini[this.currentIndex];
                  // console.log(this.immagini);
                  this.maxIndex = this.immagini.length - 1;
                }
              }
            });

            this.wmaiservice.experienceReceiversById(this.id).subscribe((data) => {
              // console.log(data);
              if (data != null) { this.receivers = data; }
              }
            );
            this.getStopsAndItems();

            if (this.esperienza != null) { this.appService.changeSelectedExperience(this.esperienza); }
            if (this.esperienza != null) { this.wgisservice.showEsperienzaByObj(this.esperienza); }

            this.mainForm.controls['titolo'].patchValue(this.esperienza.title);
            this.mainForm.controls['htmlContent'].patchValue(this.esperienza.content == null ? '' : this.esperienza.content);
          } else {
            this.router.navigate(['**']);
          }
        },
          error => {
            if (error.status === 404 || error.status === 403)
              this.router.navigate(['**']);
          }
        );
        this.loading = false;
      }
    });

    this.ostSubscription = this.appService.newOst.subscribe((ost: GisQureyResult) => {
      if (this.appService.getCurrentAppStatus() == AppStatus.EditExp) {
        if (ost != null && ost.tipo == 'ost') {
          if (this.selectedStop != null) {
            this.wmaiservice.checkTappa(this.selectedStop.stop, this.esperienza.id, ost.id).subscribe(data => {
              if (data[0].check == false) {
                // console.log(this.selectedStop.stop)
                // console.log("Ecco il nuovo ost:" + ost.id);
                this.wmaiservice.addItemFromOst(this.selectedStop.stop, this.esperienza.id, ost.id).subscribe(data => {
                  if (data != null) {
                    this.getStopsAndItems();
                    const title: string = this.translateService.instant('modal.esperienza.addOst.title');
                    const content: string = this.translateService.instant('modal.esperienza.addOst.success');
                    this.modalService
                      .open(new SimpleModal(title, content, ModalSize.Tiny))
                      .onApprove(() => "")
                      .onDeny(() => "");
                  }
                });
              } else {
                const title: string = this.translateService.instant('modal.esperienza.addOst.title');
                const content: string = this.translateService.instant('modal.esperienza.addOst.errorExist');
                this.modalService
                  .open(new SimpleModal(title, content, ModalSize.Tiny))
                  .onApprove(() => "")
                  .onDeny(() => "");
              }
            });
          } else {
            const title: string = this.translateService.instant('modal.esperienza.addOst.title');
            const content: string = this.translateService.instant('modal.esperienza.addOst.errorSelection');
            this.modalService
              .open(new SimpleModal(title, content, ModalSize.Tiny))
              .onApprove(() => "")
              .onDeny(() => "");
          }
        } else {
          const title: string = this.translateService.instant('modal.esperienza.addOst.title');
          const content: string = this.translateService.instant('modal.esperienza.addOst.errorInvalid');
          this.modalService
            .open(new SimpleModal(title, content, ModalSize.Tiny))
            .onApprove(() => "")
            .onDeny(() => "");
        }
      }
    });

  }

  //azioni da eseguire quando il componente sta per essere sostituito con un'altro
  ngOnDestroy() {
    this.appService.changeAppStatus(AppStatus.None);
    this.wgisservice.clearSelection();
    this.paramsSubscription.unsubscribe();
    this.ostSubscription.unsubscribe();
  }

  resetView() {
    this.firstStep = false;
    this.secondStep = false;
    this.thirdStep = false;
    this.fourthStep = false;

    this.canIEdit = false;
    this.canIShare = false;
    this.canIApprove = false;
    this.canIDownload = false;
    this.canIRecover = false;
    this.canIDelete = false;
    this.canIArchive = false;
    this.shareOptions = false;
    this.isRejected = false;
    this.selectedStop = null;
    this.selectedItem = null;
    this.immagini = [];
    this.allegati = [];
  }

  displaymap() {
    this.wgisservice.cmdToggleMap();
    this.isMapVisible = this.wgisservice.getMapVisible();
  }

  nextImage() {
    if (this.currentIndex >= this.maxIndex) this.currentIndex = 0;
    else this.currentIndex++;
    this.immagine = this.immagini[this.currentIndex];
  }

  previousImage() {
    if (this.currentIndex <= 0) this.currentIndex = this.maxIndex;
    else this.currentIndex--;
    this.immagine = this.immagini[this.currentIndex];
  }

  nextItemImage() {
    if (this.itemCurrentIndex >= this.itemMaxIndex) this.itemCurrentIndex = 0;
    else this.itemCurrentIndex++;
    this.itemImmagine = this.itemImmagini[this.itemCurrentIndex];
  }

  previousItemImage() {
    if (this.itemCurrentIndex <= 0) this.itemCurrentIndex = this.itemMaxIndex;
    else this.itemCurrentIndex--;
    this.itemImmagine = this.itemImmagini[this.itemCurrentIndex];
  }

  onShowImage(title: string, url: string) {
    if (url != null || url != "") {
      this.modalService
        .open(new ImageModal(title, url))
        .onDeny(() => "");
    }
  }

  changeSelectedStop(stop: Stop) {
    this.selectedStop = stop;
  }

  getStopsAndItems() {
    this.wmaiservice.queryEsperienzaStops(this.id, this.translateService.getDefaultLang()).subscribe(data => {
      if (data != null) {
        let tmpstops = data;
        this.esperienza.stops = [];
        tmpstops.forEach(stop => {
          let addstop: Stop = new Stop();
          addstop.fk_experience = this.id;
          addstop.stop = stop.stop;
          this.wmaiservice.queryEsperienzaItemsByStop(this.id, this.translateService.getDefaultLang(), stop.stop).subscribe((itemsData: Item[]) => {
            addstop.items = itemsData;
            addstop.items.forEach(item => {
              this.wmaiservice.queryEsperienzaItemFiles(item.id, this.id).subscribe(data => {
                let allegati = data;
                // console.log("Allegati",data);
                var attachments: Attachment[] = [];
                var find: boolean = false;
                var i: number;
                for (i = 0; i < allegati.length; i++) {
                  if (allegati[i].uploadedname.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG)$/)) {
                    attachments.push(allegati[i]);
                  }
                }
                item.attachtments = attachments;
              });
            })
          });
          this.esperienza.stops.push(addstop);
        });

        this.stops = this.esperienza.stops;
      }
    });
  }

  onSelectedItem(item: Item): void {
    if (item != null) {
      this.itemAllegati = [];
      this.itemImmagini = [];
      this.selectedItem = item;
      this.selectedStop = this.esperienza.stops.find(stop => stop.stop == this.selectedItem.stop);
      this.itemForm.controls['itemcontent'].patchValue(this.selectedItem.content);
      this.itemForm.controls['itemtitolo'].patchValue(this.selectedItem.title);
      this.getItemAttachments();
      this.ostDescrizione = item.ost_descrizione ? item.ost_descrizione : '';
      this.appService.changeSelectedItem(this.selectedItem);
      this.wmaiservice.selectedItem.emit(this.selectedItem);
      this.wgisservice.showItemByObj(this.selectedItem, true);
    }
  }

  onUpdateItem(item: Item) {
    if (item != null) {
      item.title = this.itemForm.controls['itemtitolo'].value ? this.itemForm.controls['itemtitolo'].value : '';
      item.content = this.itemForm.controls['itemcontent'].value ? this.itemForm.controls['itemcontent'].value : '';
      this.wmaiservice.updateEsperienzaItem(item.id, item.fk_experience, item.title, item.content).subscribe(data => {
        this.items = [];
        this.getStopsAndItems();
        this.getItems();
        const title: string = this.translateService.instant('modal.esperienza.save.title');
        const content: string = this.translateService.instant('modal.esperienza.save.confirmcontent');
        this.modalService
          .open(new SimpleModal(title, content, ModalSize.Tiny))
          .onApprove(() => "")
          .onDeny(() => "");
      });
    }
  }

  onAddFile(event: any) {
    if (this.selectedItem && this.selectedItem.id) {
      const ext = event.target.files[0].name.substr(event.target.files[0].name.lastIndexOf('.') + 1);
      const formData = new FormData();
      formData.append('file', event.target.files[0]);
      formData.append('item_id', String(this.selectedItem.id));
      formData.append('fk_experience', String(this.selectedItem.fk_experience));
      formData.append('id', String(this.auth.getID()));
      
      this.s3Service.create(formData)
        .subscribe(response => {
          const title: string = this.translateService.instant('modal.esperienza.save.title');
          const content: string = this.translateService.instant('modal.esperienza.save.confirmcontent');
          this.modalService
            .open(new SimpleModal(title, content, ModalSize.Tiny))
            .onApprove(() => "")
            .onDeny(() => "");

          this.getItemAttachments();

        }, error => {
          const title: string = this.translateService.instant('modal.esperienza.errorfile.title');
          const content: string = this.translateService.instant('modal.esperienza.errorfile.confirmcontent');
          this.modalService
            .open(new SimpleModal(title, content, ModalSize.Tiny))
            .onApprove(() => "")
            .onDeny(() => "");


         });
    }
  }

  onRemoveFile(fileId: number) {
    if (this.selectedItem && this.selectedItem.id) {
      const title: string = this.translateService.instant('modal.esperienza.removefile.title');
      const content: string = this.translateService.instant('modal.esperienza.removefile.content');
      this.modalService
        .open(new ConfirmModal(title, content, ModalSize.Tiny))
        .onApprove(() => {
          this.s3Service.delete(fileId)
            .subscribe(
              response => {
                this.wmaiservice.removeAttachmentFromItem(fileId).subscribe((data) => {
                  if (data != null) {
                    if (data[0] != null) {
                      const titles: string = this.translateService.instant('modal.esperienza.save.title');
                      const contents: string = this.translateService.instant('modal.esperienza.save.confirmcontent');
                      this.modalService
                        .open(new SimpleModal(titles, contents, ModalSize.Tiny))
                        .onApprove(() => "")
                        .onDeny(() => "");
                      this.getItemAttachments();
                    }
                  }
                }, error => {

                });
              });
        })
        .onDeny(() => "");
    }
  }

  onAddGeom() {
    if (this.selectedItem != null) {
      this.wgisservice.setMapVisible(this.isSmallScreen);
      this.isMapVisible = this.wgisservice.getMapVisible();
    }
  }

  changeGeomType(value: string) {
    this.geomtype = value;
  }

  onReset() {
    if (this.selectedItem.sysdefined)
      this.itemForm.controls['itemcontent'].patchValue('');
    else {
      this.itemForm.controls['itemtitle'].patchValue(this.selectedItem.title);
      this.itemForm.controls['itemcontent'].patchValue('');
    }
  }

  onAddItem(): void {
    if (this.selectedStop == null) {
      const title: string = this.translateService.instant('modal.esperienza.additem.title');
      const content: string = this.translateService.instant('modal.esperienza.additem.content');
      this.modalService
        .open(new SimpleModal(title, content, ModalSize.Tiny))
        .onApprove(() => '')
        .onDeny(() => "");
    } else {
      this.loading = true;
      const idWatch = navigator.geolocation.watchPosition((position) => {
        navigator.geolocation.clearWatch(idWatch);
        this.itemAllegati = [];
        this.itemImmagini = [];
        let itemname: string = this.translateService.instant('core.default.newitem');
        let newItem: Item = new Item();
        
        newItem.title = itemname;
        newItem.content = "";
        newItem.sysdefined = false;
        newItem.stop = this.selectedStop.stop;
        newItem.fk_experience = this.esperienza.id;
        var coord = [];
        coord.push(position.coords.longitude);
        coord.push(position.coords.latitude);
        var wkt = new WKT();
        newItem.geom = wkt.writeGeometry(new Point(coord));
        // this.explocalstorage.setExperience(this.esperienza);
        // console.log(this.selectedItem);
        this.wmaiservice.addItemToEsperienza(this.id, this.selectedStop.stop, itemname, newItem.content, newItem.geom).subscribe(data => {
          this.loading = false;
          this.items = []
          this.getItems();
        }, (error) => {
          this.loading = false;
          alert(JSON.stringify(error));
        });
      }, (error) => {
        navigator.geolocation.clearWatch(idWatch);
        this.loading = false;
        alert(JSON.stringify(error))
      }, { timeout: 4000, enableHighAccuracy: true });
    //   this.itemAllegati = [];
    //   this.itemImmagini = [];
    //   let itemname: string = this.translateService.instant('core.default.newitem');
    //   let newItem: Item = new Item();
      
    //   newItem.title = itemname;
    //   newItem.content = "";
    //   newItem.sysdefined = false;
    //   newItem.stop = this.selectedStop.stop;
    //   newItem.fk_experience = this.esperienza.id;
    //   //carico in esperienza

    //   navigator.geolocation.getCurrentPosition(
    //     (position: Position) => {
    //       // console.log(position);
    //       var coord = [];
    //       coord.push(position.coords.longitude);
    //       coord.push(position.coords.latitude);
    //       var wkt = new WKT();
    //       newItem.geom = wkt.writeGeometry(new Point(coord));
    //       this.explocalstorage.setExperience(this.esperienza);
    //       // console.log(this.selectedItem);
    //       this.wmaiservice.addItemToEsperienza(this.id, this.selectedStop.stop, itemname, newItem.content, newItem.geom).subscribe(data => {
    //         this.loading = false;
    //         this.items = []
    //         this.getItems();
    //       });
    //     },
    //     (error: PositionError) => {
    //         console.log('Geolocation service: ' + error.message);
    //         this.wmaiservice.addItemToEsperienza(this.id, this.selectedStop.stop, itemname, newItem.content, newItem.geom).subscribe(data => {
    //           const title: string = this.translateService.instant('modal.esperienza.additem.title');
    //           const content: string = this.translateService.instant('modal.esperienza.additem.nogps');
    //           this.modalService
    //             .open(new SimpleModal(title, content, ModalSize.Tiny))
    //             .onApprove(() => '')
    //             .onDeny(() => "");
    //           this.loading = false;
    //           this.items = []
    //           this.getItems();
    //         });
    //     }, { timeout: 4000, enableHighAccuracy: true }
    // );
    }
  }

  //viene cancellato l'Item solo se non è SYSDEFINED ovvero importato dalla SI
  onDeleteItem(item: Item): void {
    if (this.id == null) { return; }

    const title: string = this.translateService.instant('modal.esperienzaedit.item.title');
    const content: string = this.translateService.instant('modal.esperienzaedit.item.content');
    if (item != null) {
      if (item.sysdefined == false) {
        this.modalService
          .open(new ConfirmModal(title, content, ModalSize.Tiny))
          .onApprove(() => {
            this.wmaiservice.delItemToEsperienza(this.id, this.selectedItem.id).subscribe(data => {
              this.items = [];
              this.getItems();
              this.selectedItem = this.items[this.items.length - 1];
            });
            const titlec: string = this.translateService.instant('modal.esperienza.save.title');
            const contentc: string = this.translateService.instant('modal.esperienza.save.confirmcontent');
            this.modalService
              .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
              .onApprove(() => "")
              .onDeny(() => "");
          })
          .onDeny(() => "");
      }
    }
  }

  getWordsSegnalazione() {
    this.wmaiservice.getWordsByLocale(this.translateService.getDefaultLang(), 'segnalazione').subscribe(data => {
      //se non sono il proprietario dell'esperienza non posso fare la concellazione definitiva
      if (!this.isMyExp) {
        const words = data.filter(i => i.id !== 87);
        this.wordsSegnalazione = words;
      } else {
        this.wordsSegnalazione = data;
      }
    });
  }

  toggleSegnalazione() {
    this.showSegnalazione = !this.showSegnalazione;
  }

  getItems() {
    if (this.id != null) {
      this.loading = true;
      this.wmaiservice.queryEsperienzaItemsByStop(this.id, this.translateService.getDefaultLang(), this.selectedStop.stop).subscribe(data => {
        this.selectedStop.items = data;
        this.items.push(...data);
        this.selectedItem = this.items[this.items.length - 1];
        this.onSelectedItem(this.selectedItem);
        this.loading = false;
      });
    }
  }

  getItemAttachments() {
    if (this.selectedItem != null && this.id != null) {
      this.itemAllegati = [];
      this.itemImmagini = [];
      this.wmaiservice.queryEsperienzaItemFiles(this.selectedItem.id, this.id).subscribe(data => {
        const allegati = data;
        allegati.forEach(allegato => {
          if (allegato.uploadedname.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG)$/)) {
            this.itemImmagini.push(allegato);
          }
          this.itemAllegati.push(allegato);
        }
        );
        if (this.itemImmagini.length > 0) {
          this.itemCurrentIndex = 0;
          this.itemImmagine = this.itemImmagini[this.itemCurrentIndex];
          this.itemMaxIndex = this.itemImmagini.length - 1;
        }
      });
    }
  }

  share() {
    if (this.id == null || this.schedaid == null) { return; }

    const title: string = this.translateService.instant('modal.esperienza.share.title');
    const content: string = this.translateService.instant('modal.esperienza.share.content');
    this.modalService
      .open(new ConfirmModal(title, content, ModalSize.Tiny))
      .onApprove(() => {
        this.wmaiservice.updateEsperienza(this.id, this.schedaid, this.auth.getID(), this.mainForm.controls['titolo'].value, this.mainForm.controls['htmlContent'].value).subscribe(data => {
          const titlec: string = this.translateService.instant('modal.esperienza.save.title');
          const contentc: string = this.translateService.instant('modal.esperienza.save.confirmcontent');
          this.modalService
            .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
            .onApprove(() => "")
            .onDeny(() => "");
        });

        this.canIEdit = false;
        this.canIDownload = false;
        this.canIRecover = false;
        this.canIApprove = false;
        this.firstStep = false;
        this.secondStep = false;
        this.thirdStep = false;
        this.fourthStep = true;
        this.shareOptions = true;

      })
      .onDeny(() => "");
  }

  save() {
    if (this.id == null || this.schedaid == null) { return; }

    const title: string = this.translateService.instant('modal.esperienza.save.title');
    const content: string = this.translateService.instant('modal.esperienza.save.content');
    this.modalService
      .open(new ConfirmModal(title, content, ModalSize.Tiny))
      .onApprove(() => {
        this.wmaiservice.updateEsperienza(this.id, this.schedaid, this.auth.getID(), this.mainForm.controls['titolo'].value, this.mainForm.controls['htmlContent'].value).subscribe(data => {
          const titlec: string = this.translateService.instant('modal.esperienza.save.title');
          const contentc: string = this.translateService.instant('modal.esperienza.save.confirmcontent');
          this.modalService
            .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
            .onApprove(() => "")
            .onDeny(() => "");
        });
      })
      .onDeny(() => "");
  }

  //archiviazione delle schede private
  archive() {
    if (this.id == null || this.schedaid == null) { return; }

    const title: string = this.translateService.instant('modal.esperienza.archived.title');
    const content: string = this.translateService.instant('modal.esperienza.archived.content');
    this.modalService
      .open(new ConfirmModal(title, content, ModalSize.Tiny))
      .onApprove(() => {
        if (this.isUserLoggedIn) {
          this.wmaiservice.archiveEsperienza(this.id, this.schedaid, this.auth.getID()).subscribe(data => {
            // console.log(data.exist);
            if (data.exist.length > 0) {
              const title: string = this.translateService.instant('modal.esperienza.archived.title');
              const content: string = this.translateService.instant('modal.esperienza.archived.contentclone');
              this.modalService
                .open(new ConfirmModal(title, content, ModalSize.Tiny))
                .onApprove(() => {
                  this.wmaiservice.rejectEsperienzeCorrelate(data.exist).subscribe(data => {
                    const titlec: string = this.translateService.instant('modal.esperienza.archived.title');
                    const contentc: string = this.translateService.instant('modal.esperienza.archived.deleteclone');
                    this.modalService
                      .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
                      .onApprove(() => {
                        this.router.navigate(['bio/' + this.auth.getIdUser()]);
                      })
                      .onDeny(() => {
                        this.router.navigate(['bio/' + this.auth.getIdUser()]);
                      });
                  });
                })
                .onDeny(() => {
                  const titlec: string = this.translateService.instant('modal.esperienza.archived.title');
                  const contentc: string = this.translateService.instant('modal.esperienza.archived.confirmcontent');
                  this.modalService
                    .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
                    .onApprove(() => "")
                    .onDeny(() => {
                      this.router.navigate(['bio/' + this.auth.getIdUser()]);
                    });
                });
            } else {
              const titlec: string = this.translateService.instant('modal.esperienza.archived.title');
              const contentc: string = this.translateService.instant('modal.esperienza.archived.confirmcontent');
              this.modalService
                .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
                .onApprove(() => "")
                .onDeny(() => {
                  this.router.navigate(['bio/' + this.auth.getIdUser()]);
                });
            }
          });
        };
      })
      .onDeny(() => "");
  }

  recover() {
    const title: string = this.translateService.instant('modal.esperienza.recover.title');
    const content: string = this.translateService.instant('modal.esperienza.recover.content');
    if (this.esperienza != null) {
      this.modalService
        .open(new ConfirmModal(title, content, ModalSize.Tiny))
        .onApprove(() => {
          this.wmaiservice.recoverEsperienza(this.id, this.schedaid, this.auth.getID()).subscribe(data => {
            if (data != null) {
              const titlec: string = this.translateService.instant('modal.esperienza.recover.title');
              const contentc: string = this.translateService.instant('modal.esperienza.recover.confirmcontent');
              this.modalService
                .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
                .onApprove(() => "")
                .onDeny(() => "");
              this.router.navigate(['bio/' + this.auth.getIdUser()]);
            }
          });
        })
        .onDeny(() => "");
    }
  }

  shareToRAS() {
    const title: string = this.translateService.instant('modal.esperienza.share.title');
    const content: string = this.translateService.instant('modal.esperienza.share.content');
    if (this.esperienza != null) {
      this.modalService
        .open(new ConfirmModal(title, content, ModalSize.Tiny))
        .onApprove(() => {
          this.wmaiservice.cloneExperience(this.schedaid, 'wait').subscribe(data => {
            if (data != null) {
              const titlec: string = this.translateService.instant('modal.esperienza.share.title');
              const contentc: string = this.translateService.instant('modal.esperienza.share.confirmcontent');
              this.modalService
                .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
                .onApprove(() => "")
                .onDeny(() => "");
              this.router.navigate(['bio/' + this.auth.getIdUser()]);
            }
          });
        })
        .onDeny(() => "");
    }
  }

  shareToPrivate() {
    this.wmaiservice.profiloAttivo(Number(this.auth.getID())).subscribe(data => {
      if (data[0].isenabled == true) {
        const title: string = this.translateService.instant('modal.esperienza.sharePrivate.title');
        let input: string = this.translateService.instant('modal.esperienza.sharePrivate.input');
        let errorTitle: string = this.translateService.instant('modal.esperienza.sharePrivate.errorTitle');
        let errorMessage: string = this.translateService.instant('modal.esperienza.sharePrivate.errorMessage');
        if (this.esperienza != null) {
          this.modalService
            .open(new ConfirmFormModal(title, input, errorTitle, errorMessage, ModalSize.Tiny))
            .onApprove((form: NgModel) => {
              let receiver = form.value.receiver;
              this.wmaiservice.shareToPrivate(this.id, receiver, 'private').subscribe(data => {
                if (data != null) {
                  this.wmaiservice.sendSharedExperience(localStorage.getItem('email'), receiver, data.id).subscribe(data => {
                  });
                  const titlec: string = this.translateService.instant('modal.esperienza.sharePrivate.title');
                  const contentc: string = this.translateService.instant('modal.esperienza.sharePrivate.confirmcontent');
                  this.modalService
                    .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
                    .onApprove(() => {
                    })
                    .onDeny(() => "");
                  this.router.navigate(['bio/', this.auth.getIdUser()]);
                }
              }, err => {
                if (err.status == 500) {
                  const titlec: string = this.translateService.instant('modal.esperienza.sharePrivate.title');
                  const contentc: string = this.translateService.instant('modal.esperienza.sharePrivate.error');
                  this.modalService
                    .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
                    .onApprove(() => "")
                    .onDeny(() => "");
                }
              });

            })
            .onDeny(() => "");
        }
      } else {
        const titlec: string = this.translateService.instant('modal.esperienza.sharePrivate.title');
        const contentc: string = this.translateService.instant('modal.esperienza.sharePrivate.errorDisable');
        this.modalService
          .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
          .onApprove(() => "")
          .onDeny(() => "");
      }
    });
  }

  acceptPublication() {
    const title: string = this.translateService.instant('modal.esperienza.acceptPublication.title');
    const content: string = this.translateService.instant('modal.esperienza.acceptPublication.content');
    if (this.esperienza != null) {
      this.modalService
        .open(new ConfirmModal(title, content, ModalSize.Tiny))
        .onApprove(() => {
          this.wmaiservice.updateExperienceToPublic(this.id, this.schedaid, this.auth.getID()).subscribe(data => {
            if (data != null) {
              const titlec: string = this.translateService.instant('modal.esperienza.acceptPublication.title');
              const contentc: string = this.translateService.instant('modal.esperienza.acceptPublication.confirmcontent');
              this.modalService
                .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
                .onApprove(() => {
                  this.wmaiservice.sendApprovedFromRas(this.esperienza.fk_users, this.auth.getID()).subscribe((data) => {
                    //Messaggio di accettazione
                  });
                })
                .onDeny(() => "");
              if (this.auth.getIsAdmin() || this.auth.getIsSupervisor())
                this.router.navigate(['esperienza/admin']);
              else
                this.router.navigate(['/']);
            }
          });
        })
        .onDeny(() => "");
    }
  }

  activeRejectForm() {
    this.isRejected = true;
  }

  annulReject() {
    this.isRejected = false;
  }

  sendMessageReject(form: NgModel) {
    if (form.value.message != null && form.value.message != '') {
      this.rejectPublication(form.value.message);
    }
  }

  rejectPublication(message: string) {
    const title: string = this.translateService.instant('modal.esperienza.rejectPublication.title');
    const content: string = this.translateService.instant('modal.esperienza.rejectPublication.content');
    if (this.esperienza != null) {
      this.modalService
        .open(new ConfirmModal(title, content, ModalSize.Tiny))
        .onApprove(() => {
          this.wmaiservice.rejectExperience(this.id, this.schedaid, this.auth.getID()).subscribe(data => {
            if (data != null) {
              this.wmaiservice.sendRejectFromRas(this.esperienza.fk_users, message, this.auth.getID()).subscribe(data => {
                // console.log(message);
              });
              const titlec: string = this.translateService.instant('modal.esperienza.rejectPublication.title');
              const contentc: string = this.translateService.instant('modal.esperienza.rejectPublication.confirmcontent');
              this.modalService
                .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
                .onApprove(() => "")
                .onDeny(() => "");
              if (this.auth.getIsAdmin() || this.auth.getIsSupervisor())
                this.router.navigate(['esperienza/admin']);
              else
                this.router.navigate(['/']);
            }
          });
        })
        .onDeny(() => "");
    }
  }

  deleteExperience() {
    const title: string = this.translateService.instant('modal.esperienza.deleteExperience.title');
    const content: string = this.translateService.instant('modal.esperienza.deleteExperience.content');
    if (this.esperienza != null) {
      this.modalService
        .open(new ConfirmModal(title, content, ModalSize.Tiny))
        .onApprove(() => {
          this.wmaiservice.rejectExperience(this.id, this.schedaid, this.auth.getID()).subscribe(data => {
            if (data != null) {
              const titlec: string = this.translateService.instant('modal.esperienza.deleteExperience.title');
              const contentc: string = this.translateService.instant('modal.esperienza.deleteExperience.confirmcontent');
              this.modalService
                .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
                .onApprove(() => "")
                .onDeny(() => "");
              this.router.navigate(['esperienza/admin']);
            }
          });
        })
        .onDeny(() => "");
    }
  }

  submitSegnalazione() {
    if (this.id == null || this.schedaid == null) return;
    var isMyExp = Number(this.auth.getID()) == this.esperienza.fk_users;
    var params = this.segnalazioneForm.value;
    // console.log(params);
    const title: string = this.translateService.instant('modal.esperienza.alert.title');
    const content: string = this.translateService.instant('modal.esperienza.alert.content');
    this.modalService
      .open(new ConfirmModal(title, content, ModalSize.Tiny))
      .onApprove(() => {
        if (this.isUserLoggedIn) {
          this.wmaiservice.sendAlertToRas(this.id, 'esperienza', params).subscribe(data => {
          });
          //controllo se la segnalazione è per definitiva cancellazione
          if (params.segnalazioneValue == 87 && isMyExp) {
            const title: string = this.translateService.instant('modal.esperienza.delete.title');
            const content: string = this.translateService.instant('modal.esperienza.delete.content');
            this.modalService
              .open(new ConfirmModal(title, content, ModalSize.Tiny))
              .onApprove(() => {
                this.wmaiservice.deleteExperience(this.id, this.schedaid, this.auth.getID()).subscribe(data => {
                  if (isMyExp)
                    this.router.navigate(['bio/' + this.auth.getIdUser()]);
                  else
                    this.router.navigate(['esperienza/' + this.id]);
                  this.showSegnalazione = true;
                });
              })
              .onDeny(() => "");
          }

          if (params.segnalazioneValue == 1316 && isMyExp) { //Sblocco l'esperienza scaricata in autonomia
            const title: string = this.translateService.instant('modal.esperienza.delete.title');
            const content: string = this.translateService.instant('modal.esperienza.delete.content');
            this.modalService
              .open(new ConfirmModal(title, content, ModalSize.Tiny))
              .onApprove(() => {
                this.wmaiservice.undownloadedExperience(this.id, this.auth.getID()).subscribe(data => {
                  if (isMyExp)
                    this.router.navigate(['bio/' + this.auth.getIdUser()]);
                  else
                    this.router.navigate(['esperienza/' + this.id]);
                  this.showSegnalazione = true;
                });
              })
              .onDeny(() => "");
          }
        };
        this.router.navigate(['esperienza/' + this.schedaid]);
        this.showSegnalazione = true;
      })
      .onDeny(() => "");
  }

  onFinishDrawning() {
    this.getItems();
  }

  checkExpLocalStorage() {
    var check: Experience = this.explocalstorage.getExperience();
    if (check != null) {
      if (check.id == this.esperienza.id) {
        this.checkSyncronize = false;
        this.checkDownload = false;
      } else {
        this.checkDownload = false;
        this.checkSyncronize = true;
      }
    } else {
      this.checkDownload = false;
      this.checkSyncronize = true;
    }
  }

  syncronizeEsperienza() {
    var check: Experience = this.explocalstorage.getExperience();
    if (check != null) {
      if (check.id == this.esperienza.id) {
        this.downloadFromLocalStorage();
      }
    }
  }

  downloadEsperienza() {
    var check: Experience = this.explocalstorage.getExperience();
    // console.log(check);
    if (check != null) {
      if (check.id == this.esperienza.id) {
        let title: string = this.translateService.instant('modal.esperienza.download.title');
        let content: string = this.translateService.instant('modal.esperienza.download.sameExp');
        this.modalService
          .open(new ConfirmModal(title, content, ModalSize.Tiny))
          .onApprove(() => {
            this.uploadToLocalStorageMobile();
          })
          .onDeny(() => "");
      } else {
        let title: string = this.translateService.instant('modal.esperienza.download.title');
        let content: string = this.translateService.instant('modal.esperienza.download.otherExp');
        this.modalService
          .open(new ConfirmModal(title, content, ModalSize.Tiny))
          .onApprove(() => {
            this.uploadToLocalStorageMobile();
          })
          .onDeny(() => "");
      }
    } else {
      this.uploadToLocalStorageMobile();
    }
  }

  downloadFromLocalStorage() {
    var esperienza = this.explocalstorage.getExperience();
    if(esperienza){
      esperienza.content = esperienza.content == null ? '' : esperienza.content;
      this.wmaiservice.updateEsperienza(esperienza.id, esperienza.scheda_id, this.auth.getID(), esperienza.title, esperienza.content).subscribe(data => {
        this.loading = true;
        this.syncAllItems(esperienza);
      });
    } else {
      console.log("esperienza locale non esistente");
    }
  }

  syncIsDone(){
    this.loading = false;
      let titlec: string = this.translateService.instant('modal.esperienza.syncronize.title');
      let contentc: string = this.translateService.instant('modal.esperienza.syncronize.confirmcontent');
      this.modalService
        .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
        .onApprove(() => {

        })
      .onDeny(() => {
        this.removeExp();
    });
  }

  uploadToLocalStorageMobile() {
    this.loading = true;
    //qui carico la bbox intorno all'attuale exp
    var bbox = this.wgisservice.getViewExtent();
    // console.log(bbox);
    this.wmaiservice.getOstsByBBox(bbox, this.translateService.getDefaultLang()).subscribe((data) => {
      if (data != null) {
        var osts: Ost[] = data;
        this.explocalstorage.setLocalOst(osts);
        //qui memorizzo tutte le immagini da portarmi offline
        this.getAttachments();
      } else {
        this.getAttachments();
      }
    }, error => {
      this.failMessageDownload();
    });
  }

  downloadIsDone(failDownloads){
    //carico l'esperienza in localstorage
    this.explocalstorage.setExperience(this.esperienza);
    // console.log(this.esperienza);
    this.loading = false;
    let titlec: string = this.translateService.instant('modal.esperienza.download.title');
    let contentc: string = "";
    // if(failDownloads.length > 0){
    //   contentc = this.translateService.instant('modal.esperienza.download.failDownload');
    //   contentc += "\n" + failDownloads;
    // } else {
    //   contentc = this.translateService.instant('modal.esperienza.download.confirmDownload');
    // }
    contentc = this.translateService.instant('modal.esperienza.download.confirmDownload');
    this.modalService
    .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
        .onApprove(() => {
      
        })
    .onDeny(() => {
      this.checkExpLocalStorage();
    });
  }

  getAttachments() {
    var promises = [];
    // console.log("entro in attach");
    this.esperienza.stops.map(stop => {
      stop.items.map(item => {
          item.attachtments.forEach(allegato => {
            // console.log(allegato);
          if (allegato.uploadedname.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG)$/)) {
              // console.log('sto fecendo dowload');
              var path = this.esperienza.id + '/' + stop.stop.replace(/ /g, "_") + '/' + item.id;
              // if(allegato.resource_url.match(/(api.intense.netseven.it)$/)){
              //   foo.downloadMobile(allegato.resource_url, path, allegato.uploadedname);
              // } else {
                var type = foo.typeFile(allegato.uploadedname);
                let url = allegato.resource_url;
                if(allegato.sysdefined){
                  url = url.replace('http:', 'https:');
                }
                promises.push(foo.downloadMobile(url, path, allegato.id + type));
              // }
            }
          });
      });
    });

    Promise.all(promises).then(values => {
      // console.log("Esito promise download", values);
      var failDownloads = "";
      values.forEach(element => {
        if(element.value != true){
          failDownloads += element.file + "\n";
        }
      })
      this.downloadIsDone(failDownloads);
    }).catch(error => {
      this.failDownload();
      // console.log(error);
    })
  }

  failDownload(){
    foo.removeDirFolder(this.esperienza.id.toString());
    this.explocalstorage.removeExperience();
    this.explocalstorage.removeLocalItems();
    this.explocalstorage.removeLocalOst();
    this.failMessageDownload();
  }

  failMessageDownload(){
    let titlec: string = this.translateService.instant('modal.esperienza.download.title');
    let contentc: string = this.translateService.instant('modal.esperienza.download.timeout');
    this.modalService
      .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
      .onApprove(() => {
      })
      .onDeny(() => {
        this.checkExpLocalStorage();
        this.loading = false;
      });
  }

  async syncAllItems(esperienza: Experience){
    // console.log("syncAllItems");
    var promises = [];
    for (let stop of esperienza.stops) {
      for (let item of stop.items) {
        if(item.id == null || item.id == undefined){
          // console.log("Ecco item da sincronizzare: " + item.ost_id);
          if(item.ost_id != null && item.ost_id != undefined){
            await this.wmaiservice.addItemFromOst(item.stop, esperienza.id, item.ost_id).toPromise().then(data => {
              if (data != null) {
                item.id = data.item_id;
                item.attachtments.map((attachment) => {
                  const ext = attachment.uploadedname.substr(attachment.uploadedname.lastIndexOf('.') + 1);
                  let formData = new FormData();
                  formData.append('item_id', String(item.id));
                  formData.append('fk_experience', String(item.fk_experience));
                  formData.append('id', String(this.auth.getID()))
                  promises.push(foo.uploadAttachmentFile(attachment.uploadedname, item, formData, this.s3Service));
                });
              }
            });
          } else {
            await this.wmaiservice.addItemToEsperienza(esperienza.id, item.stop, item.title, item.content, item.geom).toPromise().then(data => {
              if (data != null) {
                item.id = data.data[0].items_id;
                // console.log(item)
                item.attachtments.map(attachment => {
                  const ext = attachment.uploadedname.substr(attachment.uploadedname.lastIndexOf('.') + 1);
                  let formData = new FormData();
                  formData.append('item_id', String(item.id));
                  formData.append('fk_experience', String(item.fk_experience));
                  formData.append('id', String(this.auth.getID()))
                  promises.push(foo.uploadAttachmentFile(attachment.uploadedname, item, formData, this.s3Service));
                });
              }
            });
          }
        } else {
          if(item.status == 'delete') {
            await this.wmaiservice.delItemToEsperienza(esperienza.id, item.id).toPromise().then(data => {
              // console.log("Eliminato item: " + item.id);
              promises.push(Promise.resolve(true));
            });
          } else {
            item.content = item.content == null ? '' : item.content;
            await this.wmaiservice.updateEsperienzaItem(item.id, esperienza.id, item.title, item.content).toPromise().then(data =>{
              // console.log(data);
              if (data != null) {
                item.attachtments.map(attachment => {
                  if(attachment.id == null || attachment.id == undefined){
                    const ext = attachment.uploadedname.substr(attachment.uploadedname.lastIndexOf('.') + 1);
                    let formData = new FormData();
                    formData.append('item_id', String(item.id));
                    formData.append('fk_experience', String(item.fk_experience));
                    formData.append('id', String(this.auth.getID()))
                    promises.push(foo.uploadAttachmentFile(attachment.uploadedname, item, formData, this.s3Service));
                  }
                });
              }
            });
          }
        }
      }
    };
    Promise.all(promises).then(values => {
      // console.log("Risultato promise",values);
      this.syncIsDone();
    });
  }

  getUpdatedItems() {
    var items: Item[] = [];
    this.esperienza.stops.forEach(stop => {
      stop.items.forEach(item => {
        if (item.id != null || item.id != undefined) {
          items.push(item);
        }
      });
    });
    return items;
  }

  // item nuovi dell'esperienza offline;
  getLocalItems() {
    var items: Item[] = [];
    this.esperienza.stops.forEach(stop => {
      stop.items.forEach(item => {
        if (item.id == null || item.id == undefined) {
          items.push(item);
        }
      });
    });
    return items;
  }

  addItemFromLocalItem(items: Item[]){
    
    if(items.length > 0){
      items.forEach(item => {
        // console.log("Ecco item da sincronizzare: " + item.ost_id);
        if(item.ost_id != null && item.ost_id != undefined){
          this.wmaiservice.addItemFromOst(item.stop, this.esperienza.id, item.ost_id).subscribe(data => {
            if (data != null) {
              item.id = data.item_id;
              item.attachtments.forEach(attachment => {
                const ext = attachment.uploadedname.substr(attachment.uploadedname.lastIndexOf('.') + 1);
                let formData = new FormData();
                formData.append('item_id', String(item.id));
                formData.append('fk_experience', String(item.fk_experience));
                formData.append('id', String(this.auth.getID()))
                foo.uploadAttachmentFile(attachment.uploadedname, item, formData, this.s3Service);
              })
            }
          });
        } else {
          this.wmaiservice.addItemToEsperienza(this.esperienza.id, item.stop, item.title, item.content, item.geom).subscribe(data => {
            if (data != null) {
              item.id = data.data[0].items_id;
              // console.log(item)
              item.attachtments.forEach(attachment => {
                const ext = attachment.uploadedname.substr(attachment.uploadedname.lastIndexOf('.') + 1);
                let formData = new FormData();
                formData.append('item_id', String(item.id));
                formData.append('fk_experience', String(item.fk_experience));
                formData.append('id', String(this.auth.getID()))
                foo.uploadAttachmentFile(attachment.uploadedname, item, formData, this.s3Service);
                
              })
            }
          });
        }
      });
    //pulizia del localStorage
    // this.explocalstorage.removeExperience();
    // this.explocalstorage.removeLocalItems();
    // this.explocalstorage.removeLocalOst();
    }
  }

  updateItems(items: Item[]){
    if(items.length > 0){
      items.forEach(item => {
        if(item.status == 'delete') {
          this.wmaiservice.delItemToEsperienza(this.esperienza.id, item.id).subscribe(data => {
            // console.log("Eliminato item: " + item.id);
          });
        } else {
          this.wmaiservice.updateEsperienzaItem(item.id, this.esperienza.id, item.title, item.content).subscribe(data => {
            if (data != null) {
              item.attachtments.forEach(attachment => {
                if(attachment.id == null || attachment.id == undefined){
                  const ext = attachment.uploadedname.substr(attachment.uploadedname.lastIndexOf('.') + 1);
                  let formData = new FormData();
                  formData.append('item_id', String(item.id));
                  formData.append('fk_experience', String(item.fk_experience));
                  formData.append('id', String(this.auth.getID()))
                  foo.uploadAttachmentFile(attachment.uploadedname, item, formData, this.s3Service);
                }
              })
            }
          });
        }
      });
    }
  }

  removeExp(){
    foo.removeDirFolder(this.esperienza.id.toString());
    this.explocalstorage.removeExperience();
    this.explocalstorage.removeLocalItems();
    this.explocalstorage.removeLocalOst();
    let titlec: string = this.translateService.instant('modal.esperienza.removeCache.title');
    let contentc: string = this.translateService.instant('modal.esperienza.removeCache.confirmcontent');
    this.modalService
      .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
      .onApprove(() => {
      })
      .onDeny(() => {
        this.checkExpLocalStorage();
      });
  }

  checkIcon(allegato: Attachment){
    if(allegato.uploadedname.match(/\.(pdf|txt|doc|docx|exel|PDF|TXT|DOC|DOCX|EXEL)$/)){
      return {"file alternate outline icon": true};
    } else if (allegato.uploadedname.match(/\.(mp3|MP3|wav|WAV|wma|WMA)$/)){
      return {"file audio outline icon" : true};
    } else if(allegato.uploadedname.match(/\.(3gp|avi|mp4|mpeg|mpg|3GP|AVI|MP4|MPEG|MPG)$/)){
      return {"file video outline icon": true};
    } else if(allegato.uploadedname.match(/\.(jpg|jpeg|png|gif|bmp|JPG|JPEG|PNG|GIF|BMP)$/)){
      return {"file image outline icon": true};
    } else {
      return {"download icon": true};
    }
  }
}
